import { getApps, initializeApp } from 'firebase/app'
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
  setConsent,
  setUserId,
  setUserProperties,
} from 'firebase/analytics'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_APPID,
  measurementId: import.meta.env.VITE_MEASUREMENTID,
}
export const firebaseApp = getApps()[0] || initializeApp(firebaseConfig)

let firebaseAnalytics: ReturnType<typeof getAnalytics> | null = null

const initializeAnalytics = () => {
  if (firebaseAnalytics) return firebaseAnalytics
  if (typeof window !== 'undefined' && import.meta.env.VITE_ENVIRONMENT === 'production') {
    // Set consent **BEFORE** creating the analytics instance
    setConsent({
      ad_storage: 'denied',
      analytics_storage: 'granted',
    })

    firebaseAnalytics = getAnalytics(firebaseApp)

    // Always enable collection to ensure pseudo_user_id is generated
    setAnalyticsCollectionEnabled(firebaseAnalytics, true)

    return firebaseAnalytics
  }
}

const setAnalyticsProperties = (currentUserId: string) => {
  if (!firebaseAnalytics) {
    initializeAnalytics()
  }
  if (!firebaseAnalytics) return
  setUserId(firebaseAnalytics, currentUserId, { global: true })
  setUserProperties(firebaseAnalytics, { currentUserId }, { global: true })
}

export { setAnalyticsProperties, initializeAnalytics }

const hasFirebaseAuthSession = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i) || ''
      if (key.startsWith('firebase:authUser')) return true
    }
  } catch {
    // ignore
  }
  return false
}

export const getCurrentFirebaseUser = async (): Promise<import('firebase/auth').User | null> => {
  if (!hasFirebaseAuthSession()) return null
  const { getAuth, onAuthStateChanged } = await import('firebase/auth')
  const auth = getAuth(firebaseApp)
  if (auth.currentUser) return auth.currentUser
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub()
      resolve(user)
    })
  })
}
